import React, { Component } from 'react';
import PropTypes from 'prop-types';

class FrequencyBarVisualizer extends Component {
  static propTypes = {
    freqData: PropTypes.object,
    sampleRate: PropTypes.number.isRequired
  };

  constructor(props) {
    super(props);
    this.canvas = React.createRef();
  }

  componentDidUpdate() {
    this.draw();
  }

  draw() {
    const { sampleRate, freqData } = this.props;
    //console.log(freqData);
    const canvas = this.canvas.current;
    const height = canvas.height;
    const width = canvas.width;
    const context = canvas.getContext('2d');

    context.clearRect(0, 0, width, height);
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, width, height);

    const barWidth = width / freqData.length;

    context.lineWidth = 1;
    context.strokeStyle = '#B3B3B3';
    context.fillStyle = 'rgb(0,0,0)';
    const total_lines = 10;
    for (let i = 0; i < total_lines; i++) {
      const x = (width / total_lines) * i;
      context.beginPath();
      context.moveTo(x, 0);
      context.lineTo(x, height);

      context.stroke();
      context.font = '9px Arial';
      context.textAlign = 'center';
      context.fillText((sampleRate / 2 / total_lines) * i + 'Hz ', x, 50);
    }

    for (let i = 0; i < freqData.length; i++) {
      const barHeight = (height / 256) * freqData[i];
      context.fillStyle = 'rgb(' + barHeight + ',40,40)';

      context.fillRect(barWidth * i, height - barHeight / 2, barWidth, barHeight);
    }
  }

  render() {
    return <canvas width="500" height="256" ref={this.canvas} />;
  }
}

export default FrequencyBarVisualizer;
